import { render, staticRenderFns } from "./ManageYourTeamsHolidayBlock.vue?vue&type=template&id=5b6a0c7e&scoped=true&"
import script from "./ManageYourTeamsHolidayBlock.vue?vue&type=script&lang=js&"
export * from "./ManageYourTeamsHolidayBlock.vue?vue&type=script&lang=js&"
import style0 from "./ManageYourTeamsHolidayBlock.vue?vue&type=style&index=0&id=5b6a0c7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a0c7e",
  null
  
)

export default component.exports